import { useLang } from "../i18n/LanguageContext";
import PageHeader from "../components/PageHeader";
import Timeline from "../components/Timeline";
import CTASection from "../components/CTASection";

export default function HowItWorks() {
  const { t } = useLang();
  const p = t.pages.howItWorks;

  return (
    <div data-testid="how-it-works-page">
      <PageHeader
        overline={p.overline}
        title={p.titleA}
        accent={p.accent}
        subtitle={p.subtitle}
      />
      <Timeline showHeader={false} />
      <CTASection />
    </div>
  );
}
